import { useQuery } from '@tanstack/react-query'

import { apiGetRegionDetail } from '@/apis/serviceArea/getRegionDetail'

import { SERVICE_AREA_KEYS } from '../keys/serviceArea'

interface UseGetRegionDetailParams {
  /** 조회할 광역권역. 빈 값이면 쿼리 비활성 */
  region: string | null
  /** 하위 광역권역 필터. null이면 전체 */
  subRegion?: string | null
}

/**
 * 광역권역 상세 조회 훅.
 *
 * region 이 결정되기 전(예: useGetRegionList 로딩 중)에는 enabled=false 로 호출 보류.
 * subRegion 이 바뀌면 키가 달라져 자동 refetch — FilterChips 변경에 그대로 반응.
 *
 * 캐싱 정책: 같은 (region, subRegion) 조합은 한 세션 내에서 거의 변하지 않으므로
 * staleTime/gcTime Infinity. 사용자가 전체↔북부↔남부 토글 시 첫 호출 후로는 캐시에서 즉시 반환.
 */
export const useGetRegionDetail = ({ region, subRegion }: UseGetRegionDetailParams) => {
  return useQuery({
    queryKey: [SERVICE_AREA_KEYS.REGION_DETAIL, region, subRegion ?? null],
    queryFn: () => apiGetRegionDetail({ region: region!, subRegion }),
    enabled: !!region,
    staleTime: Infinity,
    gcTime: Infinity,
  })
}
